module.exports = __webpack_public_path__ + "img/GAME_OMOK.bbbcf3d8.png";